/*const colors = {
	50: '#E5E4F0',
	100: '#BDBCD9',
	200: '#918FC0',
	300: '#6562A6',
	400: '#444093',
	500: '#231E80',
	600: '#1F1A78',
	700: '#1A166D',
	800: '#151263',
	900: '#0C0A50',
	A100: '#8885FF',
	A200: '#5552FF',
	A400: '#231FFF',
	A700: '#0A06FF',
	contrastDefaultColor: 'light'
};*/

const colors = {
	50: '#E4E6EA',
	100: '#BCC0CB',
	200: '#8F96A8',
	300: '#626C85',
	400: '#414D6A',
	500: '#1F2D50',
	600: '#1B2849',
	700: '#172240',
	800: '#121C37',
	900: '#0A1127',
	A100: '#6480FF',
	A200: '#3157FF',
	A400: '#002EFD',
	A700: '#0029E4',
	contrastDefaultColor: 'light'
};

export default colors;